import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 32 32' className={className}>
      <g>
        <rect fill='none' height='402' width='582' y='-1' x='-1' />
      </g>
      <g>
        <path
          fill={fillColor}
          d='m16.016,32c-8.815,0 -15.986,-7.17 -15.986,-15.984s7.171,-15.985 15.986,-15.985c8.813,0 15.984,7.171 15.984,15.985c0,3.925 -2.089,8.181 -3.492,10.083c-0.087,0.118 -0.223,0.192 -0.369,0.202c-0.163,0.008 -0.291,-0.046 -0.393,-0.151l-0.752,-0.779l-7.053,-7.052c-0.195,-0.195 -0.195,-0.513 0,-0.708l1.282,-1.283l-7.127,-1.91l1.911,7.128l1.364,-1.365c0.188,-0.188 0.52,-0.188 0.707,0l7.72,7.716c0.106,0.105 0.159,0.253 0.146,0.402c-0.015,0.148 -0.095,0.283 -0.219,0.367c-1.842,1.239 -5.959,3.334 -9.709,3.334zm0,-30.969c-8.264,0 -14.986,6.722 -14.986,14.985c0,8.262 6.722,14.984 14.986,14.984c3.197,0 6.714,-1.65 8.636,-2.832l-6.927,-6.926l-1.623,1.625c-0.126,0.126 -0.31,0.173 -0.483,0.13c-0.172,-0.047 -0.307,-0.182 -0.354,-0.354l-2.359,-8.803c-0.046,-0.172 0.003,-0.356 0.129,-0.483c0.125,-0.126 0.309,-0.176 0.483,-0.129l8.801,2.358c0.172,0.046 0.307,0.181 0.354,0.354c0.046,0.172 -0.004,0.356 -0.13,0.483l-1.541,1.542l7.041,7.053c1.297,-1.967 2.957,-5.622 2.957,-9.002c0,-8.263 -6.722,-14.985 -14.984,-14.985z'
        />
        <path
          fill={fillColor}
          d='m16.016,28.082c-6.654,0 -12.068,-5.413 -12.068,-12.067c0,-6.653 5.414,-12.066 12.068,-12.066c6.653,0 12.066,5.413 12.066,12.066c0,2.617 -0.824,5.106 -2.382,7.2c-0.166,0.223 -0.479,0.267 -0.7,0.103c-0.222,-0.165 -0.268,-0.479 -0.103,-0.7c1.43,-1.919 2.185,-4.202 2.185,-6.602c0,-6.102 -4.965,-11.066 -11.066,-11.066c-6.103,0 -11.068,4.964 -11.068,11.066s4.965,11.067 11.068,11.067c2.217,0 4.356,-0.653 6.188,-1.889c0.226,-0.155 0.539,-0.096 0.693,0.135c0.155,0.229 0.095,0.539 -0.135,0.693c-1.996,1.347 -4.329,2.06 -6.746,2.06z'
        />
        <path
          fill={fillColor}
          d='m16.016,24.332c-4.586,0 -8.318,-3.73 -8.318,-8.317c0,-4.585 3.731,-8.316 8.318,-8.316c4.586,0 8.316,3.73 8.316,8.316c0,1.584 -0.447,3.124 -1.293,4.453c-0.149,0.233 -0.459,0.301 -0.69,0.153c-0.232,-0.148 -0.302,-0.457 -0.153,-0.69c0.744,-1.168 1.137,-2.522 1.137,-3.916c0,-4.034 -3.282,-7.316 -7.316,-7.316c-4.035,0 -7.318,3.282 -7.318,7.316c0,4.035 3.283,7.317 7.318,7.317c1.222,0 2.431,-0.307 3.495,-0.888c0.242,-0.133 0.546,-0.044 0.678,0.199c0.133,0.242 0.043,0.546 -0.199,0.678c-1.213,0.661 -2.587,1.011 -3.975,1.011z'
        />
        <ellipse
          ry='1.316446'
          rx='1.468343'
          id='svg_5'
          cy='15.212031'
          cx='14.810134'
          fillOpacity='null'
          strokeOpacity='null'
          strokeWidth='null'
          stroke='null'
          fill={fillColor}
        />
        <ellipse
          transform='rotate(-4.88157844543457 17.797451019287056,17.23733329772948) '
          stroke='null'
          ry='2.531627'
          rx='3.746806'
          cy='17.237333'
          cx='17.797451'
          fillOpacity='null'
          strokeOpacity='null'
          strokeWidth='null'
          fill={fillColor}
        />
        <ellipse
          stroke='null'
          transform='rotate(-4.88157844543457 16.126579284667965,19.38921356201173) '
          ry='0.58144'
          rx='1.293489'
          cy='19.389214'
          cx='16.126578'
          fillOpacity='null'
          strokeOpacity='null'
          strokeWidth='null'
          fill={fillColor}
        />
        <ellipse
          stroke='null'
          transform='rotate(-4.88157844543457 16.60758590698242,20.427179336547876) '
          ry='1.24311'
          rx='1.578676'
          cy='20.427182'
          cx='16.607586'
          fillOpacity='null'
          strokeOpacity='null'
          strokeWidth='null'
          fill={fillColor}
        />
        <rect
          stroke='null'
          transform='rotate(47.862152099609375 23.902040481567386,24.28426933288574) '
          height='4.708825'
          width='15.666487'
          y='21.929859'
          x='16.068797'
          fillOpacity='null'
          strokeOpacity='null'
          strokeWidth='null'
          fill={fillColor}
        />
      </g>
    </svg>
  );
});

export default React.memo(Icon);
